import { get } from 'lodash'
import MVT from 'ol/format/MVT'
import { Layer } from 'ol/layer'
import LayerGroup from 'ol/layer/Group'
import VectorTileLayer from 'ol/layer/VectorTile'
import { VectorTile as VectorTileSource, XYZ } from 'ol/source'
import { apply } from 'ol-mapbox-style'
import React, { ReactElement, useEffect, useState } from 'react'

import { useLayer } from '../Layer/useLayer'
import { useMapSettings } from '../MapSettings/useMapSettings'
import { getMapTiles, TILE_URL } from '../mapTiles'
import { useMap } from '../useMap'

export const VectorBaseLayer = (): ReactElement => {
  const { settings } = useMapSettings()

  const [layer, setLayer] = useState<Layer | undefined>(undefined)

  const { map } = useMap()

  useLayer({ layer })

  useEffect(() => {
    const maptiles = getMapTiles()
    const maptile = get(maptiles, settings.tileLayer, maptiles.standard)

    if (!settings.isVector || !maptile.vectorStyle) {
      // console.log('Hiding vector layer')
      setLayer(undefined)
      const layers = map.getLayers().getArray()
      for (let i = layers.length - 1; i >= 0; --i) {
        if (layers[i].get('mapbox-source')) {
          map.removeLayer(layers[i])
        }
      }
      // apply(map, undefined)
      return
    }
    // console.log('Show vector layer')

    const newLayer = new VectorTileLayer({
      zIndex: 0,
      source: new VectorTileSource({
        format: new MVT(),
        url: `${TILE_URL}/data/maptiler-osm/{z}/{x}/{y}.pbf`,
      }),
    })
    const newLayerGroup = new LayerGroup({
      layers: [newLayer],
    })

    apply(map, `${TILE_URL}/styles/${maptile.vectorStyle}/style.json`)

    setLayer(newLayer)
  }, [settings.tileLayer, settings.isVector])

  return <></>
}
